import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0bbe94a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contact-info"
};
const _hoisted_2 = {
  class: "contact-info__title"
};
const _hoisted_3 = {
  class: "logo-wrapper"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "联系人", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "contact-info__hr"
}, null, -1));
const _hoisted_7 = {
  class: "contact-info__list-wrapper"
};
const _hoisted_8 = {
  class: "contact-item__title"
};
const _hoisted_9 = {
  class: "number-enchar-encrypt"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "number-enchar-encrypt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_description_item = _resolveComponent("t-description-item");
  const _component_encrypt_info = _resolveComponent("encrypt-info");
  const _component_ellipsis_text = _resolveComponent("ellipsis-text");
  const _component_list_tos = _resolveComponent("list-tos");
  const _component_t_description = _resolveComponent("t-description");
  const _directive_decode_font = _resolveDirective("decode-font");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: require('@/assets/img/customer/contact-logo.png'),
    alt: "contact"
  }, null, 8, _hoisted_4)]), _hoisted_5]), _hoisted_6, _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "contact-item"
    }, [_createElementVNode("div", _hoisted_8, "联系人" + _toDisplayString(index + 1), 1), _createVNode(_component_t_description, {
      gutter: 4,
      column: 1
    }, {
      default: _withCtx(() => [_createVNode(_component_t_description_item, {
        span: 1,
        label: "姓名",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.contact_person), 1)]),
        _: 2
      }, 1024), _createVNode(_component_t_description_item, {
        span: 1,
        label: "职位",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.job_title), 1)]),
        _: 2
      }, 1024), _createVNode(_component_t_description_item, {
        span: 1,
        label: "电话",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_encrypt_info, {
          info: item.phone
        }, null, 8, ["info"])]),
        _: 2
      }, 1024), _createVNode(_component_t_description_item, {
        span: 1,
        label: "邮箱",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(() => [item.emails && item.emails.length ? (_openBlock(), _createBlock(_component_list_tos, {
          key: 0,
          "list-data": item.emails,
          "el-popover-props": {
            placement: 'top',
            width: 'initial'
          }
        }, {
          item: _withCtx(({
            text,
            index
          }) => [_createVNode(_component_ellipsis_text, {
            disabled: item.emails.length > 2 ? true : undefined,
            class: "empty-placeholder",
            "popper-class": "number-enchar-encrypt"
          }, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("span", _hoisted_9, [_createTextVNode(_toDisplayString(text), 1)])), [[_directive_decode_font]]), item.emails.length > 2 && index === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "...")) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["disabled"])]),
          "popover-item": _withCtx(({
            text
          }) => [_withDirectives((_openBlock(), _createElementBlock("span", _hoisted_11, [_createTextVNode(_toDisplayString(text), 1)])), [[_directive_decode_font]])]),
          _: 2
        }, 1032, ["list-data"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1024), _createVNode(_component_t_description_item, {
        span: 1,
        label: "社媒",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(() => [item.social_medias && item.social_medias.length ? (_openBlock(), _createBlock(_component_ellipsis_text, {
          key: 0,
          tag: "a",
          "content-el-props": {
            href: _ctx.createProtocolUrl(item.social_medias[0]),
            target: '_blank'
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.social_medias[0]), 1)]),
          _: 2
        }, 1032, ["content-el-props"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024)]);
  }), 128))])]);
}